/* import libraries */
import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Link, useSearchParams } from 'react-router-dom';

/* import components */
import Container from 'react-bootstrap/Container';
import Menu from '../components/Menu';
import TripCard from "../components/TripCard";
import IssueCard from "../components/IssueCard";
import TopicOption from "../components/TopicOption";
import Loading from './Loading';
import Error from './Error';

/* import services */
import { saveToken } from '../utils/utils';
import { getAllTrips, getAllIssues, getSectionsForDashboard } from '../controller/controller';

  const Home = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [token, setToken] = useState();
    const [loading, setLoading] = useState(false);

    const tripsResult = useQuery(["trips", localStorage.getItem('token')], 
      () => getAllTrips(), { enabled: !!localStorage.getItem('token')});
    const issuesResult = useQuery(["issues", localStorage.getItem('token')], 
      () => getAllIssues(), { enabled: !!localStorage.getItem('token')});
    const sectionsResult = useQuery(["sections", localStorage.getItem('token')], 
      () => getSectionsForDashboard(), { enabled: !!localStorage.getItem('token')});

    useEffect(() => {
      // Save the token if opened from a mobile entry point
      if (searchParams.get("token")) {
        saveToken(searchParams.get("token"), setLoading);
        setToken(searchParams.get("token"));
      }
    }, [])

    if (loading || sectionsResult.isLoading) return <Loading/>;
    if (!sectionsResult.data) return <Error />
    
    return (
      <>
        <Menu title="RydeHELP" />
        <Container style={{ paddingTop: "20px"}}>
        {token && tripsResult?.data?.data.length > 0 ? <>
          <div className="alignTextDiffSize">
            <span className="grey font-bold">Any issues with your latest trip?</span>
              <span className="topics font-semibold" style={{ float: "right", color:"#E93864" }}>
                <Link 
                  to="/triphistory" 
                  state={{ tripsData: tripsResult.data.data }} 
                  style={{ textDecoration: "none"}}>
                  View History
                </Link>
              </span>
          </div>
            <Link 
              to={`trip/${tripsResult.data.data[0].id}`} 
              state={{ trip: tripsResult.data.data[0] }} 
              style={{ textDecoration: "none"}}>
              <TripCard trip={tripsResult.data.data[0]} showChevron={true}/>
            </Link> 
            </> : ""}
        
        {token && issuesResult?.data?.data.length > 0 ? <>
          <div className="alignTextDiffSize">
            <span className="grey font-bold">Support Requests</span>
              <span className="topics font-semibold" style={{ float: "right", color:"#E93864" }}>
                <Link 
                  to="/issuehistory" 
                  state={{ issues: issuesResult.data.data }} 
                  style={{ textDecoration: "none"}}>
                  View All
                </Link>
              </span>
          </div>
          <Link 
            to={`issue/${issuesResult.data.data[0].id}`} 
            state={{ issue: issuesResult.data.data[0] }} 
            style={{ textDecoration: "none"}}>
            <IssueCard issue={issuesResult.data.data[0]} /> 
          </Link>
          </> : ""}

          <div className="grey font-bold" style={{ fontSize:"16px"}}>Topics</div>
          {token ? 
          <TopicOption 
            searchBar={true}
            topics={sectionsResult.data?.data}
            trips={tripsResult.data} /> :<></>}
        </Container>
      </>
      );
  }

  export default Home;